import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create( { baseURL: HOST_API, withCredentials: true } );

axiosInstance.interceptors.response.use(
       ( res ) => res,
       ( error ) => Promise.reject( ( error.response && error.response.data ) || 'Something went wrong' )
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async ( args ) =>
{
       const [ url, config ] = Array.isArray( args ) ? args : [ args ];

       const res = await axiosInstance.get( url, { ...config } );

       return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
       chat: '/api/chat',
       kanban: '/api/kanban',
       calendar: '/api/calendar',
       auth: {
              me: '/api/auth/me',
              login: '/api/login',
              logout: '/api/logout',
              check: '/api/auth/check',
              sanctum: '/sanctum/csrf-cookie',
              register: '/api/auth/register',
              sendMagicLink: '/api/auth/magic-link',
              resetPassword: '/api/reset-password',
              forgetPassword: '/api/forget-password',
              loginMagicLink: '/api/auth/magic-login/consume',
       },
       mail: {
              list: '/api/mail/list',
              details: '/api/mail/details',
              labels: '/api/mail/labels',
       },
       post: {
              list: '/api/post/list',
              details: '/api/post/details',
              latest: '/api/post/latest',
              search: '/api/post/search',
       },
       product: {
              list: '/api/product/list',
              details: '/api/product/details',
              search: '/api/product/search',
       },
       signature: {
              save: '/api/signatures/save',
              update: '/api/signatures/update',
              delete: '/api/signatures/delete',
              getUnique: '/api/signatures',
              getAll: '/api/signatures/users',
       },
       trainee: {
              getAll: '/api/users',
              delete: '/api/users/delete/trainee',
       },
       contributor: {
              getAll: '/api/users',
              delete: '/api/users/delete/contributor',
       },
       user: {
              get: '/api/users',
              addUser: '/api/users/save',
              addUserProfil: '/api/users/profile/save',
              updatePassword: '/api/users/password/change',
              uploadImage: '/api/images/upload',
       },
       formations: {
              add: '/api/plannings/save',
              getAll: '/api/sessions/organizations',
              getAllSession: '/api/plannings/users',
              getAllSessionDemad: '/api/trainings/requests/users',
              reservationsList: '/api/reservations/sessions',
              ChangeStatut: '/api/reservations/trainees/update',
              updateFormationStatut: '/api/plannings/update',
              archive: '/api/archives/save',
              unArchive: '/api/archives/unarchive',
              delete: '/api/trainings/delete'

       },
};
